import { render } from "./ExpandArrowIcon.vue?vue&type=template&id=08779dc0"
import script from "./ExpandArrowIcon.vue?vue&type=script&lang=js"
export * from "./ExpandArrowIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__